import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../styles/Home.css";
import { sendEmail } from '../services/emailService';


// Hero Section Start
function Home() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({ message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus({ message: '', type: '' });

    const result = await sendEmail(formData);

    if (result.success) {
      setFormStatus({
        message: result.message,
        type: 'success'
      });
      // Reset form
      setFormData({
        name: '',
        phone: '',
        email: '',
        message: ''
      });
      // Clear message after 5 seconds
      setTimeout(() => setFormStatus({ message: '', type: '' }), 5000);
    } else {
      setFormStatus({
        message: result.message,
        type: 'error'
      });
    }

    setIsSubmitting(false);
  };

  const handleGetStarted = () => {
    navigate('/contact');
  };

  return (
    <div className="home">

      <section className="hero">

        {/* Background Video */}
        <video
          className="hero-video"
          src="/13232-246463976_medium.mp4"
          autoPlay
          loop
          muted
          playsInline
        />

        {/* Overlay */}
        <div className="hero-overlay"></div>

        {/* Content */}
        <div className="hero-content">
          <h1 className="hero-title">
            We’re a web marketing agency with <span>a strategic focus.</span>
          </h1>

          <p className="hero-subtitle">
            The growth squad behind some of the world’s most successful brands.
          </p>

          <button className="hero-btn" onClick={handleGetStarted}>
            Get Started
          </button>
        </div>

      </section>

      {/* ========================= */}
      {/* SERVICES SECTION START */}
      {/* ========================= */}

      <section className="services-section">

        <h2 className="services-heading">
          Our <span>Premium Services</span>
        </h2>

        <div className="services-grid">

          {/* Box 1 */}
          <div className="service-box">
            <h3>Web Design & Development</h3>
            <p>Modern, responsive websites that convert visitors into clients.</p>
          </div>

          {/* Box 2 */}
          <div className="service-box">
            <h3>SEO Optimization</h3>
            <p>Rank higher on Google and drive organic traffic.</p>
          </div>

          {/* Box 3 */}
          <div className="service-box">
            <h3>Meta Ads</h3>
            <p>High-converting Facebook & Instagram ad campaigns.</p>
          </div>

          {/* Box 4 */}
          <div className="service-box">
            <h3>Social Media Marketing</h3>
            <p>Grow your brand across all social platforms.</p>
          </div>

          {/* Box 5 */}
          <div className="service-box">
            <h3>Content Creation</h3>
            <p>Engaging content that builds trust and authority.</p>
          </div>

          {/* Box 6 */}
          <div className="service-box">
            <h3>Email Marketing</h3>
            <p>Convert leads with powerful email strategies.</p>
          </div>

          {/* Extra 3 services */}
          <div className="service-box">
            <h3>Video Editing</h3>
            <p>Professional video editing for reels and ads.</p>
          </div>

          <div className="service-box">
            <h3>Digital Marketing</h3>
            <p>Complete digital growth solutions for your business.</p>
          </div>

          <div className="service-box">
            <h3>Branding & Graphics</h3>
            <p>Creative branding and stunning graphic designs.</p>
          </div>

        </div>

      </section>

      {/* ========================= */}
      {/* BRANDS SECTION START */}
      {/* ========================= */}


<section className="brands-section">

  <div className="brands-content">

    <h2>Brands That Trust Us</h2>

    <p>
      These are the brands that trust us with their brand campaigns, PPC advertising,
      SEO optimization, and much more!
    </p>

    <div className="brands-grid">

      <div className="brand-box">
        <img src="imae-1.jpg" alt="brand" />
      </div>

      <div className="brand-box">
        <img src="image-2.avif" alt="brand" />
      </div>

      <div className="brand-box">
        <img src="image-3.avif" alt="brand" />
      </div>

      <div className="brand-box">
        <img src="image-4.webp" alt="brand" />
      </div>

    </div>

  </div>

</section>

{/* ========================= */}
      {/* WHY CHOOSE SECTION */}
      {/* ========================= */}


<section className="why-section">

  <h2 className="why-heading">
    Why Choose <span>Namo Digital Hub</span>
  </h2>

  <div className="why-grid">

    {/* Box 1 */}
    <div className="why-box" style={{ '--bg-image': 'url(/why-bg.webp)' }}>
      <h3>Comprehensive Approach</h3>
      <p>
        Just some techniques are not enough, a thoughtful and synchronized strategy 
        is what will overlay your brand above others, and that’s exactly what we 
        make and deliver to you.
      </p>
    </div>

    {/* Box 2 */}
    <div className="why-box" style={{ '--bg-image': 'url(/why-bg.webp)' }}>
      <h3>Results-Driven</h3>
      <p>
        Best is better than good! Providing the best, high-quality services that yield 
        actual results and cater to your needs beyond your expectations is our first 
        and last aim.
      </p>
    </div>

    {/* Box 3 */}
    <div className="why-box" style={{ '--bg-image': 'url(/why-bg.webp)' }}>
      <h3>Innovation</h3>
      <p>
        ‘Change is the only constant’ holds true for the digital reality as well. Hence, 
        we evolve continuously too so that we can equip you with the latest and updated 
        tools and tactics, giving you the much-needed competitive edge.
      </p>
    </div>

    {/* Box 4 */}
    <div className="why-box" style={{ '--bg-image': 'url(/why-bg.webp)' }}>
      <h3>Experienced Team</h3>
      <p>
        We have gathered top-notch human assets for every domain, who will collectively 
        ensure the success of your every brand campaign.
      </p>
    </div>

  </div>

</section>


{/* =========================
INDUSTRIES + REVIEWS SECTION
========================= */}

<section className="industries-reviews">

  <h2 className="industry-heading">
    A Unified Vision That Caters <br />
    to Diverse Industry Demands
  </h2>

  {/* INDUSTRIES GRID */}

  <div className="industry-grid">

    <div className="industry-box">❤️ Healthcare</div>
    <div className="industry-box">💲 Finance</div>
    <div className="industry-box">🏨 Restaurant</div>
    <div className="industry-box">🛒 eCommerce</div>

    <div className="industry-box">🔋 EV</div>
    <div className="industry-box">☁️ SaaS</div>
    <div className="industry-box">🌍 Travel</div>
    <div className="industry-box">🎵 Entertainment</div>

    <div className="industry-box">🤝 On Demand</div>
    <div className="industry-box">📱 Social Media</div>
    <div className="industry-box">📦 Logistics</div>
    <div className="industry-box">📚 EdTech</div>

  </div>


  {/* CLIENT REVIEWS */}

  <h3 className="review-title">
    What Clients Say About Our Digital Marketing
  </h3>

  {/* Slider 1 */}

  <div className="review-slider">
    <div className="review-track">
      <div className="review-set">
        <div className="review-box">Our SEO traffic increased 3x within months.</div>
        <div className="review-box">Meta ads campaign delivered amazing ROI.</div>
        <div className="review-box">Professional team and fast delivery.</div>
        <div className="review-box">Best digital marketing agency we worked with.</div>
        <div className="review-box">Our brand visibility improved massively.</div>
      </div>
      <div className="review-set" aria-hidden="true">
        <div className="review-box">Our SEO traffic increased 3x within months.</div>
        <div className="review-box">Meta ads campaign delivered amazing ROI.</div>
        <div className="review-box">Professional team and fast delivery.</div>
        <div className="review-box">Best digital marketing agency we worked with.</div>
        <div className="review-box">Our brand visibility improved massively.</div>
      </div>
    </div>
  </div>


  {/* Slider 2 */}

  <div className="review-slider reverse">
    <div className="review-track">
      <div className="review-set">
        <div className="review-box">Lead generation improved drastically.</div>
        <div className="review-box">Creative branding strategies helped us grow.</div>
        <div className="review-box">Amazing support and communication.</div>
        <div className="review-box">Highly recommended for digital marketing.</div>
        <div className="review-box">Great team and impressive marketing results.</div>
      </div>
      <div className="review-set" aria-hidden="true">
        <div className="review-box">Lead generation improved drastically.</div>
        <div className="review-box">Creative branding strategies helped us grow.</div>
        <div className="review-box">Amazing support and communication.</div>
        <div className="review-box">Highly recommended for digital marketing.</div>
        <div className="review-box">Great team and impressive marketing results.</div>
      </div>
    </div>
  </div>

</section>



<section className="contact-section">
  <div className="contact-wrapper">

    {/* LEFT SIDE */}
    <div className="contact-left">
      <span className="tag">Let's Discuss</span>
      <h1>
        You Have Questions And <br />
        We Have Answer
      </h1>
    </div>

    {/* RIGHT SIDE */}
    <div className="contact-right">
      <h3>Ready To Talk With Us?</h3>

      <form onSubmit={handleFormSubmit}>
        <input 
          type="text" 
          name="name"
          placeholder="Enter Name*" 
          value={formData.name}
          onChange={handleInputChange}
          required 
        />
        <input 
          type="tel" 
          name="phone"
          placeholder="Phone Number" 
          value={formData.phone}
          onChange={handleInputChange}
          required 
        />
        <input 
          type="email" 
          name="email"
          placeholder="Enter E-mail*" 
          value={formData.email}
          onChange={handleInputChange}
          required 
        />
        <textarea 
          name="message"
          placeholder="Project Description*" 
          value={formData.message}
          onChange={handleInputChange}
          required
        ></textarea>

        {formStatus.message && (
          <div className={`form-message form-message-${formStatus.type}`}>
            {formStatus.message}
          </div>
        )}

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Sending...' : 'Submit'}
        </button>
      </form>
    </div>

  </div>
</section>
      
    </div>
  );
}
export default Home;

